// packages/api-client/queries/contestsEditionsStageTableJudges/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createContestsEditionsStageTableJudgesQueries = (requests, queryClient) => ({
    useListContestsEditionsStageTableJudges: (params, options = {}) => {
        return useQuery({
            queryKey: ["contests-editions-stage-table-judges", params],
            queryFn: async ({ queryKey }) => {
                const [_key, params] = queryKey;
                return requests.listContestsEditionStageTableJudges(params);
            },
            ...options,
        });
    },
    useCreateContestsEditionsStageTableJudge: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageTableJudgeAttrs) => {
            return requests.createContestsEditionStageTableJudge(contestsEditionsStageTableJudgeAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stage-table-judges"],
            });
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-judges"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useDeleteContestsEditionsStageTableJudge: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageTableJudgeAttrs) => {
            return requests.deleteContestsEditionStageTableJudge(contestsEditionsStageTableJudgeAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stage-table-judges"],
            });
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-judges"],
            });
            options.onSuccess?.(...args);
        },
    }),
    usePromoteContestsEditionsStageTableJudge: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageTableJudgeAttrs) => {
            return requests.promoteContestsEditionStageTableJudge(contestsEditionsStageTableJudgeAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stage-table-judges"],
            });
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stage-tables"],
            });
            options.onSuccess?.(...args);
        },
    }),
});
//# sourceMappingURL=index.js.map